import { modelT } from "../../redux/features/ui/ui.types";

export const modelsClassicSofa: modelT[] = [
  {
    img: "/images/assets/ClassicSofa/SofaPlus.png",
    label: "Sofa Plus",
    labelUI: "Sofa Plus",
    nameValueThreekit: "Sofa Plus",
    description: "Room to gather",
    subcategory: "Sofas",
    // Clarification: () => {
    //   return <span>3 seat cushions</span>;
    // },
  },
  {
    img: "/images/assets/ClassicSofa/Sofa.png",
    label: "Sofa",
    labelUI: "Sofa",
    nameValueThreekit: "Sofa",
    description: "Everyday classic",
    subcategory: "Sofas",
    // Clarification: () => {
    //   return <span>2 seat cushions</span>;
    // },
  },
  {
    img: "/images/assets/ClassicSofa/LoftSofa.png",
    label: "Loft Sofa",
    labelUI: "Loft Sofa",
    nameValueThreekit: "Loft Sofa",
    description: "Compact comfort",
    subcategory: "Sofas",
    // Clarification: () => {
    //   return <span>2 seat cushions</span>;
    // },
  },
  {
    img: "/images/assets/ClassicSofa/Loveseat.png",
    label: "Loveseat",
    labelUI: "Loveseat",
    nameValueThreekit: "Loveseat",
    description: "Cozy for two",
    subcategory: "Sofas",
    // Clarification: () => {
    //   return <span>2 seat cushions</span>;
    // },
  },
  {
    img: "/images/assets/ClassicSofa/ArmChair.png",
    label: "Arm Chair",
    labelUI: "Arm Chair",
    nameValueThreekit: "Arm Chair",
    description: "Versatile classic",
    subcategory: "Accent Chairs",
    // Clarification: () => {
    //   return <span></span>;
    // },
  },
  {
    img: "/images/assets/ClassicSofa/CuddleChair.png",
    label: "Cuddle Chair",
    labelUI: "Cuddle Chair",
    nameValueThreekit: "Cuddle Chair",
    description: "Curl-up chair",
    subcategory: "Accent Chairs",
    // Clarification: () => {
    //   return <span></span>;
    // },
  },
  {
    img: "/images/assets/ClassicSofa/Ottoman.png",
    label: "Ottoman",
    labelUI: "Ottoman",
    nameValueThreekit: "Ottoman",
    description: "Classic",
    subcategory: "Accent Ottomans",
    // Clarification: () => {
    //   return <span></span>;
    // },
  },
  {
    img: "/images/assets/ClassicSofa/CuddleOttoman.png",
    label: "Cuddle Ottoman",
    labelUI: "Cuddle Ottoman",
    nameValueThreekit: "Cuddle Ottoman",
    description: "Wider and longer ottoman",
    subcategory: "Accent Ottomans",
    // Clarification: () => {
    //   return <span></span>;
    // },
  },
];
